import React from "react";

export default function Youtube(props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-[48px] h-[48px] lg:w-[56px] lg:h-[56px] fill-primary stroke-black bg-white hover:bg-primary rounded-full ${props.customClasses}`}
    >
      <circle
        cx="19.778"
        cy="19.778"
        r="19.028"
        stroke="#1F2022"
        strokeWidth=".75"
        className="group-hover:fill-primary"
      />
      <path
        d="M19.929 14h.122c4.47 0 4.47 0 6.395.264l.12.017c.667.102 1.245.381 1.663.921.59.842.607 2.043.666 3.036l.005.072c.04.626.04 1.253.04 1.88v.084c-.001.82-.004 1.637-.082 2.454l-.008.08c-.212 2.239-.212 2.239-.957 2.888-1.012.794-2.567.692-3.794.747l-.095.005a86.21 86.21 0 0 1-3.9.072h-.111c-6.997-.001-6.997-.001-8.019-1.007-1.32-1.436-.942-4.761-.866-6.582.143-3.256.143-3.256.997-4.068a2.46 2.46 0 0 1 1.283-.58c.83-.135 1.677-.168 2.514-.206l.093-.005a60.957 60.957 0 0 1 .873-.033c1.02-.033 2.04-.04 3.06-.039Zm-1.684 3.644v5.232c.142-.057.267-.116.4-.19l.126-.07.132-.074.069-.038c.31-.173.62-.35.926-.532.676-.402 1.362-.788 2.046-1.178l.578-.33.19-.109.08-.045.054-.031a2.806 2.806 0 0 0-.34-.225l-.115-.066a55.116 55.116 0 0 0-.125-.071l-.13-.075-.27-.155-.615-.355a299.1 299.1 0 0 0-.242-.14l-.48-.276c-.467-.27-.936-.54-1.405-.807L19 18.04l-.118-.067c-.16-.092-.318-.187-.476-.281-.082-.053-.082-.053-.162-.047Z"
        fill="#1F2022"
        className="group-hover:fill-white group-hover:stroke-2"
      />
    </svg>
  );
}
